export default __webpack_public_path__ + "static/media/t1Sala4.9bbe85af.jpg";